import src from "IMAGE";
export default { src, width: 516, height: 94, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABEREWISEhJkFRUVdD07HnedlDmabWcoaVZRH1NuaChqelMI2j2w+iYAAAAASUVORK5CYII="};
